import randomcolor from 'randomcolor'

import type { EntityPerson } from '@/types/library/Entity'
import type { User } from '@/types/User'

export const getPersonFullName = (
  person: EntityPerson,
  includeSuffix: boolean = true,
) => {
  return (
    includeSuffix
      ? person.suffixes && person.suffixes.length > 0
        ? `${person.first_name ?? ''} ${person.last_name ?? ''}, ${person.suffixes.join(', ')}`.trim()
        : `${person.first_name} ${person.last_name}`
      : `${person.first_name} ${person.last_name}`
  ).trim()
}

export const getPersonColor = (person: EntityPerson, theme: string) => {
  return randomcolor({
    seed: getPersonFullName(person),
    luminosity: theme === 'dark' ? 'dark' : 'light',
  })
}

export const getPersonFirstName = (
  person: EntityPerson | null | undefined,
  orgUser: User | null | undefined,
) => {
  if (orgUser) return orgUser.first_name
  return person?.first_name ?? ''
}

export const getPersonLastName = (
  person: EntityPerson | null | undefined,
  orgUser: User | null | undefined,
) => {
  if (orgUser) return orgUser.last_name
  return person?.last_name ?? ''
}

export const getPersonName = (
  person: EntityPerson | null | undefined,
  orgUser: User | null | undefined,
) => {
  return `${getPersonFirstName(person, orgUser)} ${getPersonLastName(person, orgUser)}`
}

export const getPersonEmail = (
  person: EntityPerson | null | undefined,
  orgUser: User | null | undefined,
) => {
  if (orgUser) return orgUser.email
  return person?.email ?? null
}
